import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";

@Injectable({
  providedIn: "root"
})
export class CookieFacade {
  private taskSort = "taskSortDescriptor";

  constructor(private cookieService: CookieService) {}

  private get(name: string): unknown {
    return JSON.parse(this.cookieService.get(name));
  }

  private set(name: string, value: unknown): void {
    this.cookieService.set(name, JSON.stringify(value), {
      expires: 30,
      path: "/"
    });
  }

  private check(name: string): boolean {
    return this.cookieService.check(name);
  }

  public getTaskSort(defaultValue: unknown): unknown {
    if (!this.check(this.taskSort)) {
      return defaultValue;
    }

    return this.get(this.taskSort);
  }

  public setTaskSort(value: unknown): void {
    this.set(this.taskSort, value);
  }
}
